import React from 'react';
import './App.css';
import MainPage from './pages/main/MainPage';
import { 
          Routes, 
          Route 
    } from 'react-router-dom';

// component import
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';

// page import
import HistoryPage from './pages/1_YonseiFc/1_HistoryPage';
import CompanyPage from './pages/1_YonseiFc/2_CompanyPage';
import Center from './pages/1_YonseiFc/3_Center';
import Partners from './pages/1_YonseiFc/4_Partners';

import TeamPage from './pages/3_Program/1_TeamProgram';
import StaffPage from './pages/2_Team/2_StaffPage';

import TeamProgram from './pages/3_Program/1_TeamProgram';
import SchedulePage from './pages/3_Program/2_SchedulePage';

import NewsPage from './pages/4_Media/1_NewsPage';
import PhotoPage from './pages/4_Media/2_PhotoPage';
import MoviePage from './pages/4_Media/3_MoviePage';

import Notice from './pages/5_Community/1_Notice';
import HelpPage from './pages/5_Community/2_HelpPage';

import PayPage from './pages/PayPage';

import Signup from './pages/6_Auth/1_SignUp';
import Login from './pages/6_Auth/2_Login';


const App = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path='/' element={<MainPage />} />
        
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/center" element={<Center />} />
        <Route path="/parters" element={<Partners />} />

        <Route path="/team" element={<TeamPage />} />
        <Route path="/staff" element={<StaffPage />} />

        <Route path="/teamProgram" element={<TeamProgram />} />
        <Route path="/schedule" element={<SchedulePage />} />

        <Route path="/news" element={<NewsPage />} />
        <Route path='/photo' element={<PhotoPage />} />
        <Route path="/movie" element={<MoviePage />} />

        <Route path="/notice" element={<Notice />} />
        <Route path="/help" element={<HelpPage />} />
        
        <Route path="/payment" element={<PayPage />} />

        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
